import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'popover-card-header',
  templateUrl: './popover-card-header.component.html',
  styleUrls: ['./popover-card-header.component.scss'],
  standalone: false,
})
export class PopoverCardHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
